<template>
  <div>
    <nav class="navbar affix navbar-expand-lg fixed-top navbar-light">
    <div class="container-fluid align-items-center">
      <!-- Logo -->
      <router-link to="/" class="navbar-brand">
        <img src="images/logo.png" width="70" alt="Image">
      </router-link>
      <!-- End Logo -->

      <!-- Responsive Menu Button -->
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false" aria-label="Toggle navigation">
        <span class="menu-icon">
            <span class="menu-icon__bar"></span>
            <span class="menu-icon__bar"></span>
            <span class="menu-icon__bar"></span>
        </span>
      </button>
      <!-- End Responsive Menu Button -->

      <!-- Navigation -->
      <div class="collapse navbar-collapse" id="navbarSupportedContent">

        <!-- Links -->
        <ul class="navbar-nav mx-auto">
          <li class="nav-item dropdown">
            <a class="nav-link" href="#home">Home</a>
          </li>
          <li class="nav-item">
            <a href="#overview" class="nav-link">Overview</a>
          </li>
        </ul>
        <!-- End Links -->

        <!-- Nav Right Item -->
        <div class="site-header--right d-flex justify-content-center align-items-center">
          <template v-if="!$store.getters.loggedIn">
            <router-link to="register" class="btn btn-link">Register</router-link>
            <span class="mx-3">or</span>
            <router-link to="login" class="btn btn-link">Login</router-link>
          </template>
          <router-link v-else to="legislations" class="btn btn-link">Begin Consultation</router-link>
        </div>
        <!-- End Nav Right Item -->
      </div>
    </div>
  </nav>
  <!-- End Nav -->
  <!-- ========== End Header ========== -->

  <!-- ========== MAIN ========== -->
  <!-- Hero Secction -->
  <div class="intro" id="home" style="min-height: 100vh;">
    <div class="screen-v-100">
      <div class="l-v-center">
        <div class="container">
          <div class="intro-content">
            <div class="row align-items-lg-center">

              <div class="col-md-5">
                <!-- Info -->
                <h1 class="intro-lead-title mb-3">Nigeria ICT Innovation and Entrepreneurship Vision</h1>
                <!-- End Info -->

                <!-- Call to Action -->
                <div class="intro-cta-group d-flex justify-content-center justify-content-sm-start">
                  <router-link :to="$store.getters.loggedIn ? 'legislations' : 'register'" class="btn btn-xl btn-primary">Get started</router-link>
                  <router-link to="tour" class="btn btn-xl btn-primary">Take The Tour</router-link>
                </div>
                <!-- End Call to Action -->
              </div>

              <div class="col-md-6 col-lg-5 ml-auto">
                <!-- Hero Image -->
                <div class="intro-img">
                  <img src="images/previews/image-2.svg" class="img-fluid" alt="Image">
                </div>
                <!-- End Hero Image -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Wave shape  -->
    <figure class="img-shape absolute-bottom">
      <img src="assets/images/wave.svg" alt="Image">
    </figure>
    <!-- End Wave shape  -->
  </div>
  <!-- End Hero Secction -->

  <!-- ========== OVERVIEW SECTION ========== -->
  <section class="section-spacer u-bg-gradient--primary u-text--light" id="overview">
    <div class="container">
      <div class="row">
        <div class="col-md-7 mx-auto">
          <!--Section Header-->
          <header class="section-header text-center">
            <h2 class="section-title h1">Overview</h2>
          </header>
          <!--End Section Header-->
        </div>
      </div>

      <div class="row mb-5 align-items-start">
        <div class="row">
          <div class="col-md-9 mx-auto">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4">
                <div class="feature-list feature-list-md">
                    <span class="u-icon u-icon--light u-icon--xl mb-20 u-icon--rounded feature-box--icon">
                      <i class="icon ion-md-cog"></i>
                    </span>
                  <h3>Review</h3>
                  <p>Review legislations, visions and goals. Make sure you understand.</p>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4">
                <div class="feature-list feature-list-md">
                    <span class="u-icon u-icon--light u-icon--xl mb-20 u-icon--rounded feature-box--icon">
                      <i class="icon ion-ios-flower"></i>
                    </span>
                  <h3>Comment</h3>
                  <p>Participate in the legal process and comment on legislations, visions and goals.</p>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4">
                <div class="feature-list feature-list-md">
                    <span class="u-icon u-icon--light u-icon--xl mb-20 u-icon--rounded feature-box--icon">
                      <i class="icon ion-md-trending-up"></i>
                    </span>
                  <h3>Rate</h3>
                  <p>Or simply let your opinion be known.</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4">
                <div class="feature-list feature-list-md">
                    <span class="u-icon u-icon--light u-icon--xl mb-20 u-icon--rounded feature-box--icon">
                      <i class="icon ion-md-chatbubbles"></i>
                    </span>
                  <h3>Discuss</h3>
                  <p>Discuss on the issues affecting our country.</p>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4">
                <div class="feature-list feature-list-md">
                    <span class="u-icon u-icon--light u-icon--xl mb-20 u-icon--rounded feature-box--icon">
                      <i class="icon ion-ios-finger-print"></i>
                    </span>
                  <h3>Influence</h3>
                  <p>Directly influence the people leading our country. Put your fingerprint on the future of our country.</p>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4">
                <div class="feature-list feature-list-md">
                    <span class="u-icon u-icon--light u-icon--xl mb-20 u-icon--rounded feature-box--icon">
                      <i class="icon ion-ios-globe"></i>
                    </span>
                  <h3>Access</h3>
                  <p>Have your say, at any time or from anywhere that’s convenient to you.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="text-align: center;">

      <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A//niiev.ictinnovation.gov.ng" class="ion-logo-facebook" target="_blank"></a>
      <a href="https://twitter.com/home?status=https%3A//niiev.ictinnovation.gov.ng" class="ion-logo-twitter" target="_blank"></a>
      <a href="https://plus.google.com/share?url=https%3A//niiev.ictinnovation.gov.ng" class="ion-logo-googleplus"></a>

    </div>
      
  </section>


        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
  export default {
    name: "landing"
  };
</script>

<style scoped>
  .navbar .container-fluid {
    max-width: 1300px;
    margin: 0 auto;
  }

  p {
    text-indent: 0;
  }
</style>